import { HpEditIcon } from "@/themes/hp-client/icons";
import { useTheme } from "@/contexts/theme";
import { EditPencilIcon } from "@/components/icons/edit-pencil-icon";

const EditMenuIcon = (props: any) => {
  const { isUnderline, color, width, height } = props;
  const strokeColor = color || "var(--theme-primary-300, #8283BE)";
  const { currentTheme } = useTheme();
  const isHp = currentTheme === "hp-client";

  if (isHp) {
    return (
      <HpEditIcon
        color={color ?? "var(--theme-combobox-icon-color, #1A1A1A)"}
        width={width ?? 24}
        height={height ?? 24}
      />
    );
  }
  if (isUnderline) {
    return (
      <EditPencilIcon
        color={strokeColor}
        width={width ?? 16}
        height={height ?? 16}
      />
    );
  }
  return (
    <svg
      width={width ?? "16"}
      height={height ?? "16"}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.33398 1.33337H6.00065C2.66732 1.33337 1.33398 2.66671 1.33398 6.00004V10C1.33398 13.3334 2.66732 14.6667 6.00065 14.6667H10.0007C13.334 14.6667 14.6673 13.3334 14.6673 10V8.66671"
        stroke={strokeColor}
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M10.6933 2.01338L5.43992 7.26671C5.23992 7.46671 5.03992 7.86005 4.99992 8.14671L4.71325 10.1534C4.60659 10.88 5.11992 11.3867 5.84659 11.2867L7.85325 11C8.13325 10.96 8.52659 10.76 8.73325 10.56L13.9866 5.30671C14.8933 4.40005 15.3199 3.34671 13.9866 2.01338C12.6533 0.680046 11.5999 1.10671 10.6933 2.01338Z"
        stroke={strokeColor}
        stroke-width="1.5"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M9.93945 2.76672C10.3861 4.36006 11.6328 5.60672 13.2328 6.06006"
        stroke={strokeColor}
        stroke-width="1.5"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export { EditMenuIcon };
